import { Component, OnInit, OnChanges, SimpleChanges, ViewEncapsulation, ViewChild, ElementRef } from '@angular/core';
import { Vraag, Antwoord } from '@models/claims';
import { VraagboomTextResultaat } from '@models/vragenboom';
import { BaseVraagControlDirective } from '../base/base-vraag-control';
import { RequiredValidator } from '../../../utils/validation/required.validator';
import { TextValidator } from '../../../utils/validation/text.validator';
import { Devicetype } from '../../../models/imports/generic';
import { WindowService } from '../../../services/window-service';
import { DataService } from '@components/public_api';

@Component({
  selector: 'app-textarea',
  templateUrl: './textarea.component.html',
  styleUrls: ['./textarea.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TextareaComponent extends BaseVraagControlDirective<VraagboomTextResultaat> implements OnInit, OnChanges {
  @ViewChild('textAreaField', { static: true }) textAreaElement: ElementRef;

  maxlength = 1200;
  lengte = 0;
  placeholder = '';
  numberRows = 8;

  _tekst: string;
  get tekst(): string {
    return this._tekst;
  }
  set tekst(val: string) {
    this._tekst = val;
    this.notifyAntwoord();
  }

  constructor(
    _dataService: DataService,
    private _windowService: WindowService
  ) {
    super(_dataService);
  }

  ngOnInit() {
    if (this.antwoordResultaat != null && this.antwoordResultaat.vraag.id === this.vraag.id && this.antwoordResultaat.resultaat != null) {
      this.tekst = this.antwoordResultaat.resultaat.value;
    } else {
      this.tekst = '';
    }

    if (this.vraag?.antwoorden?.length > 0 && this.vraag.antwoorden[0].validatieParameters) {
      const validatie = this.vraag.antwoorden[0].validatieParameters.filter(v => v.type_validatie === 'MAX_LENGTE');
      if (validatie?.length > 0) {
        this.maxlength = Number(validatie[0].validatie_parameters);
      }
    }

    this.placeholder = this.vraag.antwoorden[0].standaard_waarde_tekst;

    if (this._windowService.deviceType() <= Devicetype.TabletPortrait) {
      this.numberRows = 4;
    }
  }

  initialize(changes: SimpleChanges): void { }

  notifyAntwoord() {
    let antwoorden: Antwoord[] = [];
    if (this.vraag?.antwoorden?.length > 0) {
      antwoorden = this.vraag.antwoorden;
    }

    this.setAntwoord(antwoorden, new VraagboomTextResultaat(this.tekst.trim()));
  }

  validate(vraag: Vraag, antwoorden: Antwoord[], resultaat: VraagboomTextResultaat): boolean {
    return antwoorden?.length >= 1 &&
      RequiredValidator.isValidText(vraag, resultaat) &&
      TextValidator.isValidMaxLength(antwoorden, resultaat);
  }
}
